export function getRecaptchaSiteKey() {
  return String(process.env.REACT_APP_RECAPTCHA_SITE_KEY || "").trim();
}

function whenReady(resolve, reject) {
  if (!window.grecaptcha?.ready) {
    reject(new Error("recaptcha"));
    return;
  }
  window.grecaptcha.ready(() => resolve(window.grecaptcha));
}

export function loadRecaptchaScript() {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha?.render) {
      whenReady(resolve, reject);
      return;
    }

    const existing = document.querySelector("script[data-recaptcha-v2='true']");
    if (existing) {
      if (window.grecaptcha) {
        whenReady(resolve, reject);
        return;
      }
      existing.addEventListener("load", () => whenReady(resolve, reject), { once: true });
      existing.addEventListener("error", () => reject(new Error("recaptcha")), { once: true });
      return;
    }

    window.__onRecaptchaV2Load = () => whenReady(resolve, reject);
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?onload=__onRecaptchaV2Load&render=explicit";
    script.async = true;
    script.defer = true;
    script.dataset.recaptchaV2 = "true";
    script.onerror = () => reject(new Error("recaptcha"));
    document.body.appendChild(script);
  });
}

export function getRecaptchaResponse(widgetId) {
  if (widgetId == null || !window.grecaptcha?.getResponse) return "";
  return String(window.grecaptcha.getResponse(widgetId) || "").trim();
}

export function resetRecaptcha(widgetId) {
  if (widgetId == null || !window.grecaptcha?.reset) return;
  window.grecaptcha.reset(widgetId);
}
